import type { LocalizedDict } from '../index'

// Admin Settings → Integrations → Media generation
// (features/admin/MediaGeneration.tsx). "Magnific" is a provider name.

export type MediaGenerationStrings = {
  sourceLabels: { db: string; env: string }
  title: string
  encryptedNote: string
  simulationNotice: string
  loading: string
  loadError: string
  savedToast: string
  savedToastDescription: string
  saveErrorToast: string
  unknownError: string
  deactivatedToast: string
  deactivateErrorToast: string
  removedToast: string
  removeErrorToast: string
  providerSubtitle: string
  credentialsLabel: string
  updated: (when: string) => string
  deactivate: string
  remove: string
  apiKey: string
  apiKeyHint: string
  active: string
  savingNote: string
  cancel: string
  saving: string
  rotateCredentials: string
  saveCredentials: string
  deactivated: string
}

export const mediaGenerationI18n: LocalizedDict<MediaGenerationStrings> = {
  en: {
    sourceLabels: { db: 'saved credentials', env: 'server config' },
    title: 'Media Generation',
    encryptedNote: 'Provider credentials are encrypted at rest and remain write-only.',
    simulationNotice:
      'Simulation mode — media generation credentials require the live backend (real-API build). Saving is disabled here.',
    loading: 'Loading…',
    loadError: 'Could not load media generation credentials.',
    savedToast: 'Magnific credentials saved',
    savedToastDescription: 'The API key is encrypted and only its last four characters are shown.',
    saveErrorToast: 'Could not save credentials',
    unknownError: 'Unknown error',
    deactivatedToast: 'Magnific credentials deactivated',
    deactivateErrorToast: 'Could not deactivate credentials',
    removedToast: 'Magnific credentials removed',
    removeErrorToast: 'Could not remove credentials',
    providerSubtitle: 'Server-managed provider endpoint',
    credentialsLabel: 'Magnific credentials',
    updated: (when) => `Updated ${when}`,
    deactivate: 'Deactivate',
    remove: 'Remove',
    apiKey: 'API key',
    apiKeyHint: 'Encrypted at rest and never displayed again.',
    active: 'Active',
    savingNote:
      'Saving credentials does not enable generation. Studio Generation remains separately controlled.',
    cancel: 'Cancel',
    saving: 'Saving…',
    rotateCredentials: 'Rotate credentials',
    saveCredentials: 'Save credentials',
    deactivated: 'Deactivated',
  },
  tr: {
    sourceLabels: { db: 'kayıtlı bilgiler', env: 'sunucu ayarı' },
    title: 'Medya Üretimi',
    encryptedNote: 'Sağlayıcı bilgileri şifreli saklanır ve yalnızca yazılabilir; geri okunamaz.',
    simulationNotice:
      'Simülasyon modu — medya üretimi bilgileri için canlı sunucu gerekir (gerçek API sürümü). Burada kaydetme kapalı.',
    loading: 'Yükleniyor…',
    loadError: 'Medya üretimi bilgileri yüklenemedi.',
    savedToast: 'Magnific bilgileri kaydedildi',
    savedToastDescription: 'API anahtarı şifreli saklanır ve yalnızca son dört karakteri gösterilir.',
    saveErrorToast: 'Bilgiler kaydedilemedi',
    unknownError: 'Bilinmeyen hata',
    deactivatedToast: 'Magnific bilgileri devre dışı bırakıldı',
    deactivateErrorToast: 'Bilgiler devre dışı bırakılamadı',
    removedToast: 'Magnific bilgileri silindi',
    removeErrorToast: 'Bilgiler silinemedi',
    providerSubtitle: 'Sunucu tarafından yönetilen sağlayıcı bağlantısı',
    credentialsLabel: 'Magnific bilgileri',
    updated: (when) => `Güncellendi: ${when}`,
    deactivate: 'Devre dışı bırak',
    remove: 'Sil',
    apiKey: 'API anahtarı',
    apiKeyHint: 'Şifreli saklanır ve bir daha gösterilmez.',
    active: 'Aktif',
    savingNote:
      'Bilgileri kaydetmek üretimi açmaz. Studio Generation ayrıca kontrol edilir.',
    cancel: 'Vazgeç',
    saving: 'Kaydediliyor…',
    rotateCredentials: 'Bilgileri değiştir',
    saveCredentials: 'Bilgileri kaydet',
    deactivated: 'Devre dışı',
  },
}
